import React, { forwardRef } from 'react';

const Input = forwardRef(
  (
    {
      label,
      type = 'text',
      placeholder,
      value,
      onChange,
      error,
      required = false,
      disabled = false,
      className = '',
      helpText = '',
      leftIcon,
      rightIcon,
      id,
      ...props
    },
    ref
  ) => {
    const inputId = id || (label ? `input-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
    const hasLeft = !!leftIcon;
    const hasRight = !!rightIcon;

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-app-text mb-1">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </label>
        )}
        <div className="relative">
          {hasLeft && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-app-text-secondary pointer-events-none">
              {leftIcon}
            </span>
          )}
          <input
            ref={ref}
            id={inputId}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
            required={required}
            aria-invalid={!!error}
            className={`
              w-full py-2 border rounded-lg text-app-text
              ${hasLeft ? 'pl-10' : 'pl-4'}
              ${hasRight ? 'pr-10' : 'pr-4'}
              focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent
              disabled:bg-app-surface disabled:cursor-not-allowed disabled:text-app-text-secondary
              ${error ? 'border-error' : 'border-gray-300'}
              ${className}
            `.trim().replace(/\s+/g, ' ')}
            {...props}
          />
          {hasRight && (
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-app-text-secondary">
              {rightIcon}
            </span>
          )}
        </div>
        {error && <p className="mt-1 text-sm text-error">{error}</p>}
        {helpText && !error && (
          <p className="mt-1 text-xs text-app-text-secondary">{helpText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
